import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/Auth";
import MainLayout from "@/layouts/Main";
import store from "@/store";
import Error404 from "./views/auth/404";
import Error500 from "./views/auth/500";
import LoginDev from "@/login";
import Login from "@/components/system/Auth/Login";
import routerWorkLeave from "@/views/mainApp/components/workLeaveApp/router";
import routerWorkOvertime from "@/views/mainApp/components/workOvertimeApp/router";
import routerHelpdesk from "@/views/mainApp/components/helpdeskApp/router";
import routerContract from "@/views/mainApp/components/contractApp/router";
import routerSubcontract from "@/views/mainApp/components/subContractApp/router";
import routerDocumentISO from "@/views/mainApp/components/documentISOApp/router";
import routerDocumentISONew from "@/views/mainApp/components/document-iso/router";
import routerDocumentInNew from "@/views/mainApp/components/document-in/router";
import routerDocumentOutNew from "@/views/mainApp/components/document-out/router";
import routerAsset from "@/views/mainApp/components/asset/router";
import routerTravelRequest from "@/views/mainApp/components/travelRequest/router";
import routerVehicleUsage from "@/views/mainApp/components/vehicleUsage/router";
import routerReportApproval from "@/views/mainApp/components/reportApproval/router";
import routerInteractiveForm from "@/views/mainApp/components/interactiveForm/router";

const IS_DEV_MODE = process.env.NODE_ENV === "development";

const dashboardUrl = "/app/dashboard";

const dashboardRouter = IS_DEV_MODE
  ? {
      path: "/app/dashboard",
      name: "dashboard",
      component: () => import("@/views/dashboard"),
    }
  : {
      path: "/app/dashboard",
      name: "dashboard",
      beforeEnter(to, from, next) {
        // Put the full page URL including the protocol http(s) below
        window.location.replace(
          "https://phuthai.sharepoint.com/sites/eoffice/apps/app/default.aspx#/modules"
        );
      },
      // redirect: dashboardUrl,
    };

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // modules
    // notifications
    {
      path: "/notifications",
      redirect: "notifications",
      component: MainLayout,
      name: "notifications",
      children: [
        {
          path: "/notifications",
          component: () =>
            import("@/components/layout/Topbar/Actions/NotificationTabs"),
        },
      ],
    },
    {
      path: "",
      redirect: dashboardUrl,
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: "/auth/login",
          name: "signIn",
          // meta: {
          //   title: "Sign In",
          // },
          component: IS_DEV_MODE ? LoginDev : Login,
        },
        {
          ...dashboardRouter,
        },
        {
          path: "/app/my-info",
          name: "myInfo",
          // meta: {
          //   title: "myInfo",
          // },
          component: () => import("@/views/infoMyUser"),
        },
        // notifications
        {
          path: "/notifications",
          redirect: "notifications",
          component: MainLayout,
          name: "notifications",
          children: [
            {
              path: "/notifications",
              component: () =>
                import("@/components/layout/Topbar/Actions/NotificationTabs"),
            },
          ],
        },
        routerWorkOvertime,
        routerWorkLeave,
        // routerDocumentOut,
        // routerDocumentIn,
        routerHelpdesk,
        routerContract,
        routerSubcontract,
        // routerDocumentISO,
        routerDocumentInNew,
        routerDocumentOutNew,
        routerDocumentISONew,
        routerAsset,
        routerTravelRequest,
        routerVehicleUsage,
        routerReportApproval,
        routerInteractiveForm,
      ],
    },

    // Redirect to 404
    {
      path: "/cau-hinh/*",
      redirect: "error/404",
      hidden: true,
    },

    //print modules
    {
      name: "freightRequestAndDeliveryOrderPrint",
      path: "/app/contract/freight-request-and-delivery-order/:id/print",
      component: () =>
        import(
          "@/views/mainApp/components/contractApp/childApp/freightRequestAndDeliveryOrder/detail-item"
        ),
      props: { readOnly: true },
      meta: {
        appName: "freightRequestAndDeliveryOrderPrint",
      },
    },
    {
      name: "freightRequestAndGoodReceivingNotePrint",
      path: "/app/contract/freight-request-and-good-receiving-note/:id/print",
      component: () =>
        import(
          "@/views/mainApp/components/contractApp/childApp/freightRequestAndGoodReceivingNote/detail-item"
        ),
      props: { readOnly: true },
      meta: {
        appName: "freightRequestAndGoodReceivingNotePrint",
      },
    },
    {
      name: "travelRequestPrint",
      path: "/app/travel-request/:id/print",
      component: () =>
        import("@/views/mainApp/components/travelRequest/detail-view"),
      props: { isViewPrint: true },
      meta: {
        appName: "travelRequestPrint",
      },
    },
    {
      name: "vehicleUsagePrint",
      path: "/app/travel-request/vehicle-usage/:id/print",
      component: () =>
        import(
          "@/views/mainApp/components/travelRequest/detail-view-vehicle.vue"
        ),
      props: { isViewPrint: true },
      meta: {
        appName: "vehicleUsagePrint",
      },
    },
    {
      name: "jobRequestPrint",
      path: "/app/contract/job-request/:id/print",
      component: () =>
        import(
          "@/views/mainApp/components/contractApp/childApp/jobRequest/detail-item"
        ),
      props: { readOnly: true },
      meta: {
        appName: "jobRequestPrint",
      },
    },
    {
      name: "handoverPrintForm",
      path: "/app/asset/handover/:handoverId/print",
      component: () =>
        import(
          "@/views/mainApp/components/asset/components/form/handover/handover-form.detail"
        ),
      props: { isViewPrint: true },
    },
    {
      name: "interactiveFormPrint",
      path: "/app/interactive-form/:id/print",
      component: () =>
        import("@/views/mainApp/components/interactiveForm/detail-view"),
      props: { isViewPrint: true },
      meta: {
        appName: "interactiveFormPrint",
      },
    },
    {
      name: "interactiveFormPrintComments",
      path: "/app/interactive-form/:id/print-comments",
      component: () =>
        import("@/views/mainApp/components/interactiveForm/detail-view"),
      props: { isViewPrint: true, isViewCommentsPrint: true },
      meta: {
        appName: "interactiveFormPrint",
      },
    },
  ],
});
router.beforeEach((to, from, next) => {
  next();
});
export default router;
